import PageSize from "./page-size/page-size";
import Pagination from "./pagination";
import PropTypes from "prop-types";
import React, { Component } from "react";
import ResultLinks from "./result-links";
import DropdownSelect from "../shared/dropdown-select/dropdown-select";
import ToggleButtons from "../shared/toggle-buttons/toggle-buttons";

class ResultsHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: this.props.resultState.view,
    };
  }

  changeView = (e) => {
    const view = e.target.value;
    this.setState({ view: view });
    this.props.changeView(view);
  };

  handleChange = (option, name) => {
    this.props.changeFilter(name, option.value);
  };

  render() {
    let bannerOptions = [
      { value: "all", label: "all homes" },
      { value: "openHouses", label: "open houses" },
      { value: "contract", label: "in contract" },
      { value: "newListing", label: "recently listed" },
      { value: "hasVideos", label: "videos" },
    ];
    if (this.props.regionUrl === "houston") {
      bannerOptions.push({ value: "innerLoop", label: "inner loop" });
    }

    let sortFields = [
      { value: "currentPrice", label: "price" },
      { value: "interior", label: "square feet" },
      { value: "totalBedrooms", label: "beds" },
      { value: "baths", label: "baths" },
    ];
    if (this.props.resultState.filter.bannerFilter === "openHouses") {
      sortFields.push({ value: "openhousedate", label: "open house date" });
    }
    if (
      this.props.location &&
      this.props.location.query &&
      this.props.location.query.latitude &&
      this.props.location.query.longitude
    ) {
      sortFields.push({ value: "distance", label: "distance" });
    }
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-16">
            <div className="list-table search-table">
              <div className="page-head-nav">
                <h2 className="page-head" id="results-title">
                  Search results
                </h2>
                <div className="inheadline-link">
                  <div className="action-symbols">
                    <ResultLinks regionUrl={this.props.regionUrl} />
                  </div>
                </div>
              </div>

              <div
                id="human-readable-filter"
                className="for-light col-xs-11 col-xxs-16 flush-left"
              >
                <PageSize
                  resultState={this.props.resultState}
                  sizeOptions={[12, 24, 60]}
                  changeFilter={this.props.changeFilter}
                />

                <div className="header-dropdowns">
                  <DropdownSelect
                    label="Showing"
                    id="bannerFilter"
                    options={bannerOptions}
                    handleChange={this.handleChange}
                    selected={this.props.resultState.filter.bannerFilter}
                  />
                  <DropdownSelect
                    label="sorted by"
                    id="sortField"
                    options={sortFields}
                    handleChange={this.handleChange}
                    selected={this.props.resultState.filter.sortField}
                  />
                </div>
              </div>

              <div className="right-box col-xs-5 col-xxs-16">
                <Pagination
                  count={this.props.resultState.resultCount}
                  pageSize={this.props.resultState.filter.resultsPerPage}
                  activePage={this.props.resultState.filter.activePage}
                  params={this.props.params}
                  location={this.props.location}
                  changeFilter={this.props.changeFilter}
                />

                <div className="simple-toggle hidden-xxs">
                  <ToggleButtons
                    name="gridListToggle"
                    options={[
                      { label: "Photo View", value: "photo" },
                      { label: "List View", value: "list" },
                    ]}
                    value={this.state.view}
                    onChange={this.changeView}
                    labelClass=""
                  />
                </div>
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ResultsHeader.propTypes = {
  changeFilter: PropTypes.func.isRequired,
  changeView: PropTypes.func.isRequired,
  resultState: PropTypes.object.isRequired,
  regionUrl: PropTypes.string.isRequired,
  params: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default ResultsHeader;



// WEBPACK FOOTER //
// ./src/components/search/results-header.js